module.exports = __webpack_public_path__ + "static/media/login_background.59d316cb.jpg";